// Size option helpers

import React from 'react';
import PurchaseLimitMessaging, {
  hasMetLimitedProductCartQuantity,
  PurchaseLimitTagDataTypes,
} from 'src/scripts/templates/_shared/ui-components/PurchaseLimitItem/PurchaseLimitMessaging';
import { getCartData } from 'src/scripts/utils/cart';
import { lowerCasedBlacklistedOptionValues } from 'src/scripts/utils/constants';
import { IVariant, IProduct } from '../../types/PDP';
import { computeQuantityRemaining } from '../ScarcityMessaging/InitUrgencyMessage';
import { UrgencyMessage } from '../ScarcityMessaging/UrgencyMessage';

// * [IMPROVEMENT] refactor component to have better separation of concern, move some of the parent logic into here?
export const SizeSelectionTitle = (props: {
  currentVariant: IVariant | undefined;
  productType: string;
  sizeSelection: string | undefined;
  soldOutCopy: string;
  purchaseLimitTagData?: PurchaseLimitTagDataTypes;
  shouldHideInventory?: boolean;
}) => {
  const { currentVariant, productType, sizeSelection, soldOutCopy, purchaseLimitTagData, shouldHideInventory } = props;
  const { sku = '', availableForSale = false } = currentVariant || {};
  let quantityRemain = computeQuantityRemaining(currentVariant);

  const cartData = getCartData();
  const hasMetLimit =
    purchaseLimitTagData && hasMetLimitedProductCartQuantity(cartData, currentVariant?.sku, purchaseLimitTagData);

  return (
    <div className="size__info small-p black">
      <span className="title-option-label">
        {sizeSelection && (
          <>
            {sizeSelection} {getSizeNumbers(sizeSelection, productType, sku)}
            <span
              className={`title-option-value ${
                !availableForSale ? 'alert__text' : hasMetLimit ? 'disabled__text' : ''
              }`}
            >
              {!availableForSale || shouldHideInventory ? (
                ` - ${soldOutCopy}`
              ) : hasMetLimit && purchaseLimitTagData ? (
                <>
                  {' - '}
                  <PurchaseLimitMessaging purchaseLimitTagData={purchaseLimitTagData} messageType={'variant'} />
                </>
              ) : (
                ''
              )}
            </span>
          </>
        )}
      </span>
      {!hasMetLimit && !shouldHideInventory && (
        <UrgencyMessage
          quantityLeft={quantityRemain}
          className="variantSelect"
          style={{
            color: '#B8152B',
          }}
        />
      )}
    </div>
  );
};
export const getSizeNumbers = (size: string, productType: string, sku: string | undefined | null): string | null => {
  const sanitizedSku = sku ? sku : '';
  const PRODUCT_SIZES_MAP: [
    () => boolean,
    {
      [s: string]: string | undefined;
    }
  ][] = [
    [() => productType === 'Women:Swimwear:Tops', {}],
    [() => productType === 'Women:Swimwear:Bottoms', {}],
    [() => productType === 'Women:Swimwear:One Piece', {}],
    [
      () => productType.startsWith('Women:'),
      {
        XXS: '(00-0)',
        XS: '(2-4)',
        S: '(4-6)',
        M: '(8-10)',
        L: '(12-14)',
        XL: '(16-18)',
        '2XL': '(20-22)',
      },
    ],
    [
      () => productType.startsWith('Men:') && ['M5', 'M6'].some((prefix) => sanitizedSku.startsWith(prefix)),
      {
        S: '(28"-30")',
        M: '(32"-34")',
        L: '(36"-38")',
        XL: '(40"-42")',
        '2XL': '(44" - 44")',
      },
    ],
  ];

  for (const entry of PRODUCT_SIZES_MAP) {
    const [validator, sizesHash] = entry;

    if (validator()) {
      const sizeWanted = Object.entries(sizesHash).length > 0;
      const sizeStr = sizeWanted ? sizesHash[size] : '';
      if (sizeStr !== undefined) return sizeStr;
    }
  }

  return '';
};
export function computeProductOptionsWithMetadata(product: IProduct, tags?: string[]) {
  const { options, productType } = product;
  return Object.entries(options).map(([optionName, optionValues], optionIndex) => {
    const allValuesInBlackList = optionValues.every((item) =>
      lowerCasedBlacklistedOptionValues.includes(item && item.toLowerCase().replace(' ', ''))
    );
    const shouldRenderSelectionsUI =
      !allValuesInBlackList &&
      (optionValues.length > 1 || (!productType.startsWith('Beauty:') && optionName === 'Color'));
    return {
      optionName,
      optionValues,
      optionNumber: optionIndex + 1,
      allValuesInBlackList,
      shouldRenderSelectionsUI,
    };
  });
}
